'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = typeof alert !== 'undefined' ? alert : function () {};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/dom/showInfo.js
// module id = 86
// module chunks = 0